import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import {
  currentOrganizationSelector,
  orgTariffesSelector,
} from "../store/selectors";

function useOrganizationLimits() {
  const currentOrganization = useSelector(currentOrganizationSelector);
  const organizationsTariffes = useSelector(orgTariffesSelector);

  // console.log("is from limits: ", currentOrganization, organizationsTariffes);

  if (!currentOrganization || !organizationsTariffes) return null;
  if (
    !organizationsTariffes[currentOrganization.id] ||
    organizationsTariffes[currentOrganization.id].status !== "ACTIVE"
  )
    return null;
  return organizationsTariffes[currentOrganization.id]?.usage || null;
}

export default useOrganizationLimits;
